import React, { useContext } from "react";
import QuestionRow from "../CustomInputs/QuestionRow/QuestionRow";
import {
  useDriverHHM,
} from "../HouseholdContext/DriverHHMContext";

const DriverHHM_ConfirmForm = ({ context, isLargeScreen }) => {
  const driverHHMContext = useDriverHHM();
  //   const driversHHMs = context.householdChangeClass.driversHHMs;
  const driverHHM = driverHHMContext.driverHHM;

  //   const blPipOption = [4, 5, 6].includes(context?.userData?.pipOption);
  const blIsRelative = ["Spouse", "Child", "Parent", "Other Relative"].includes(
    driverHHM?.driverInfo?.relationshipToPolicyholder
  );
  const blHasInsurance = driverHHM?.driverInfo?.hasInsurance === "1";
  const blDriverAge = driverHHMContext.calculateAge() >= 16;
  const blSameHousehold = driverHHM?.addressInfo?.sameHousehold === "1";
  const blIsMichigan = context?.userData?.state == "Michigan";
  const blIsNewJersey = context?.userData?.state == "New Jersey";
  const blIsPennsylvania = context?.userData?.state == "Pennsylvania";
  const blUniversityAge = driverHHMContext.calculateAge() <= 24;
  const blIsDriver =
    (((blIsMichigan||blIsNewJersey) && driverHHM?.driverInfo?.licenseStatus == "Valid") ||
      (blIsPennsylvania &&
        driverHHM?.driverInfo?.licenseStatus ==
        "Valid Pennsylvania License")) &&
    driverHHM?.driverInfo?.ownInsurance == 0;


  const formName =
    driverHHM?.componentTracker == "Update HHM"
      ? "Update Household Member"
      : driverHHM?.componentTracker == "Add HHM"
        ? "Add Household Member"
        : driverHHM?.componentTracker;

  const isDriverHHM = driverHHM?.componentTracker == "Add Driver" ||
   blIsDriver || 
   ((driverHHM?.editType && driverHHM?.editType == "No longer resides in household." && driverHHM?.componentTracker == "Update Driver")||
   (driverHHM?.editType && driverHHM?.editType != "No longer resides in household." && driverHHM?.componentTracker != "Update Driver"))
   ?
  "Driver"
  :
  "Household Member";

  const isUpdate =
    driverHHM?.componentTracker == "Update Household Member" ||
    driverHHM?.componentTracker == "Update HHM" ||
    driverHHM?.componentTracker == "Update Driver";

  return (
    <>
      <h5 className="text-primary text-center fw-bold mb-4 text-uppercase">
        {formName}
      </h5>

      {context?.addressChangeClass?.requestType !== "Address Change" &&
        <QuestionRow
          label="Requested Effective Date"
          value={
            driverHHM.requestedEffDate
          }
        />
      }

      <QuestionRow
        label="Full Name"
        value={
          driverHHM.userInfo?.middleInitial
            ? driverHHM.userInfo.firstName +
            " " +
            driverHHM.userInfo.middleInitial +
            ". " +
            driverHHM.userInfo.lastName
            : driverHHM.userInfo.firstName + " " + driverHHM.userInfo.lastName
        }
      />
      {driverHHM.userInfo?.dobMonth &&
        driverHHM.userInfo?.dobDay &&
        driverHHM.userInfo?.dobYear && (
          <>
            <QuestionRow
              label="Date of Birth"
              value={driverHHMContext?.formatDate(
                driverHHM.userInfo.dobMonth +
                " " +
                driverHHM.userInfo.dobDay +
                " " +
                driverHHM.userInfo.dobYear
              )}
            />
          </>
        )}
      {driverHHM.userInfo?.maritalStatus && (
        <>
          <QuestionRow
            label="Marital Status"
            value={driverHHM.userInfo.maritalStatus}
          />
        </>
      )}
      {driverHHM.userInfo?.gender && (
        <>
          <QuestionRow label="Gender" value={driverHHM.userInfo.gender} />
        </>
      )}
      {driverHHM.driverInfo?.licenseStatus && !isUpdate && (
        <>
          <QuestionRow
            label={isDriverHHM + "'s License Status"}
            value={driverHHM.driverInfo.licenseStatus}
          />
        </>
      )}
      {driverHHM.driverInfo?.licenseAge && (
        <>
          <QuestionRow
            label="Age Licensed"
            value={driverHHM.driverInfo.licenseAge}
          />
        </>
      )}
      {driverHHM.driverInfo?.licenseState && (
        <>
          <QuestionRow
            label="License State"
            value={driverHHM.driverInfo.licenseState}
          />
        </>
      )}
      {driverHHM.driverInfo?.licenseNumber && (
        <>
          <QuestionRow
            label="License Number"
            value={driverHHM.driverInfo.licenseNumber}
          />
        </>
      )}
      {/* {driverHHM?.driverInfo?.maintainOwnInsurance && (
        <>
          <QuestionRow
            label={`Does this ${isDriverHHM.toLowerCase()} maintain his/her own auto insurance?`}
            value={
              driverHHM.driverInfo.maintainOwnInsurance == "0" ? "No" : "Yes"
            }
          />
        </>
      )} */}
      {driverHHM?.driverInfo?.ownInsurance && (
        <>
          <QuestionRow
            // label={`Has this ${isDriverHHM.toLowerCase()} obtained their own auto insurance?`}
            label={`Does this ${isDriverHHM.toLowerCase()} maintain ${blIsNewJersey?"their":"his/her"} own auto insurance?`}
            value={driverHHM?.driverInfo?.ownInsurance == "0" ? "No" : "Yes"}
          />
        </>
      )}
      {driverHHM?.userInfo?.relationshipToPolicyholder && (
        <>
          <QuestionRow
            label={`Relationship to ${context?.userData?.firstName}`}
            value={driverHHM?.userInfo?.relationshipToPolicyholder}
          />
        </>
      )}
      {driverHHM?.driverInfo?.hasInsurance && (
        <>
          <QuestionRow
            label={`Does this driver have health insurance?`}
            value={driverHHM?.driverInfo?.hasInsurance == "0" ? "No" : "Yes"}
          />
        </>
      )}
      {driverHHM?.driverInfo?.insuranceType && (
        <>
          <QuestionRow
            label={`Type of health insurance`}
            value={driverHHM?.driverInfo?.insuranceType}
          />
        </>
      )}
      {driverHHM?.addressInfo?.sameHousehold && (
        <>
          <QuestionRow
            label="Resides in same household?"
            value={driverHHM?.addressInfo?.sameHousehold == "1" ? "Yes" : "No"}
          />
        </>
      )}
      {driverHHM?.vehicleInfo?.takeVehiclesToNewAddress && (
        <>
          <QuestionRow
            label={`Is this ${isDriverHHM.toLowerCase()} taking any policy vehicles with them to their new address?`}
            value={
              driverHHM?.vehicleInfo?.takeVehiclesToNewAddress == "1"
                ? "Yes"
                : "No"
            }
          />
          {driverHHM?.vehicleInfo?.takeVehiclesToNewAddress === "1" && (
            <QuestionRow
              label={`Which vehicles will be taken to the new address?`}
              value={driverHHM?.vehicleInfo?.vehiclesAtNewAddress?.map(
                ({ Year, Make, Model }) => (
                  <li>{`${Year} ${Make} ${Model}`}</li>
                )
              )}
            />
          )}
        </>
      )}
      {driverHHM?.addressInfo?.driverStreetName &&
        driverHHM?.addressInfo?.driverCity &&
        driverHHM?.addressInfo?.driverZip && (
          <>
            <QuestionRow
              label={`What is this ${isDriverHHM}'s street?`}
              value={driverHHM?.addressInfo?.driverStreetName}
            />
            {driverHHM?.addressInfo?.driverAptNumber && (
              <QuestionRow
                label={`What is this ${isDriverHHM}'s apt?`}
                value={driverHHM?.addressInfo?.driverAptNumber}
              />
            )}
            <QuestionRow
              label={`What is this ${isDriverHHM}'s city?`}
              value={driverHHM?.addressInfo?.driverCity}
            />
            <QuestionRow
              label={`What is this ${isDriverHHM}'s zip?`}
              value={driverHHM?.addressInfo?.driverZip}
            />
          </>
        )}
      {driverHHM?.addressInfo?.resideInState && (
        <>
          <QuestionRow
            label={`Does this person currently reside in ${context?.userData?.state}?`}
            value={driverHHM?.addressInfo?.resideInState == "1" ? "Yes" : "No"}
          />
        </>
      )}
      {driverHHM?.userInfo?.occupation &&
        driverHHM?.editType !== "No longer resides in household." && (
          <>
            <QuestionRow
              label="What is this person's occupation?"
              value={driverHHM?.userInfo?.occupation}
            />
          </>
        )}
      {driverHHM?.violationInfo?.convicted && (
        <>
          <QuestionRow
            label="Has this person been convicted in the past 5 years of fraud or intent to defraud involving an insurance claim or an application for insurance; Or has this person successfully been denied in the past 5 years, payment of a claim over $1,000.00 under an auto insurance policy, if there was evidence or fraud or the intent to defraud involving an insurance claim or application?"
            value={driverHHM?.violationInfo?.convicted == "1" ? "Yes" : "No"}
          />
        </>
      )}
      {driverHHM?.userInfo?.militaryMember &&
        driverHHM?.editType !== "No longer resides in household." && (
          <>
            <QuestionRow
              label={`Is the ${isDriverHHM.toLowerCase()} a member of any branch of military?`}
              value={driverHHM?.userInfo?.militaryMember == "1" ? "Yes" : "No"}
            />
          </>
        )}
      {driverHHM?.disabilityInfo?.disorders && (
        <>
          <QuestionRow
            label={`Does the ${isDriverHHM.toLowerCase()} have a disorder or condition that may impair their ability to safely operate a motor vehicle, including but not limited to Narcolepsy, Syncope, Blindness, or Seizures?`}
            value={driverHHM?.disabilityInfo?.disorders == "1" ? "Yes" : "No"}
          />
        </>
      )}

      {blIsRelative && blIsMichigan && (
        <>
          <QuestionRow
            label={`Does this ${isDriverHHM.toLowerCase()} have health insurance?`}
            value={driverHHM?.driverInfo?.hasInsurance == "1" ? "Yes" : "No"}
          />
          {driverHHM?.addressInfo?.hasInsurance === "1" && (
            <QuestionRow
              label={`What type of health insurance does this ${isDriverHHM.toLowerCase()} have?`}
              value={driverHHM?.driverInfo?.insuranceType}
            />
          )}
        </>
      )}

      {blIsMichigan && isDriverHHM == "Driver" && !isUpdate && (
        <>
          <QuestionRow
            label={`Has the ${isDriverHHM.toLowerCase()} been convicted of, or has been subject to an order of disposition of the family division of circuit court for a violation of any of the following, within the last 3 years:`}
            value={""}
          />
          <QuestionRow
            label={
              "a. Moving violation causing death or serious impairment of body function; or any other Michigan law for which a violation constitutes a felony resulting from the operation of a motor vehicle."
            }
            value={
              driverHHM?.violationInfo?.seriousMovingViolations == "1"
                ? "Yes"
                : "No"
            }
            subHeading={true}
            isLargeScreen={isLargeScreen}
          />
          <QuestionRow
            label={"b. Operation of motor vehicle while under influence."}
            value={
              driverHHM?.violationInfo?.underInfluence == "1" ? "Yes" : "No"
            }
            subHeading={true}
            isLargeScreen={isLargeScreen}
          />
          <QuestionRow
            label={
              "c. Failure to stop when involved in an accident that results in serious impairment of a body function or death."
            }
            value={driverHHM?.violationInfo?.impairment == "1" ? "Yes" : "No"}
            subHeading={true}
            isLargeScreen={isLargeScreen}
          />
          <QuestionRow
            label={
              "d. Failure to stop when involved in an accident that results in injury to any individual."
            }
            value={driverHHM?.violationInfo?.ftsInjury == "1" ? "Yes" : "No"}
            subHeading={true}
            isLargeScreen={isLargeScreen}
          />
          <QuestionRow
            label={
              "e. Failure to stop when involved in an accident that results in damage to a vehicle operated by or attended by any individual."
            }
            value={
              driverHHM?.violationInfo?.vehicleDamage == "1" ? "Yes" : "No"
            }
            subHeading={true}
            isLargeScreen={isLargeScreen}
          />
          <QuestionRow
            label={
              "f. Failure to provide required information or to provide reasonable assistance to an injured individual."
            }
            value={
              driverHHM?.violationInfo?.provideInfoFailure == "1" ? "Yes" : "No"
            }
            subHeading={true}
            isLargeScreen={isLargeScreen}
          />
          <QuestionRow
            label={
              "g. Reckless Driving, or a similar violation under the laws of any other state or municipality in or outside of Michigan."
            }
            value={
              driverHHM?.violationInfo?.recklessDriving == "1" ? "Yes" : "No"
            }
            subHeading={true}
            isLargeScreen={isLargeScreen}
          />
        </>
      )}
      {driverHHM?.disabilityInfo?.physicalImpairments && (
        <>
          <QuestionRow
            label={`Does this ${isDriverHHM.toLowerCase()} have any mental or physical impairments, other than those listed above, that would impair their ability to operate a motor vehicle safely (Not including prescription eyeglasses or contact lenses)?`}
            value={
              driverHHM?.disabilityInfo?.physicalImpairments == "1"
                ? "Yes"
                : "No"
            }
          />
        </>
      )}
      {driverHHM?.driverInfo?.diffNameLicensed && (
        <>
          <QuestionRow
            label={`Has this ${isDriverHHM.toLowerCase()} been licensed under a different name within the past 36 months?`}
            value={
              driverHHM?.driverInfo?.diffNameLicensed == "1" ? "Yes" : "No"
            }
          />
        </>
      )}
      {driverHHM?.driverInfo?.prevName && (
        <>
          <QuestionRow
            label={`Previous License Name`}
            value={
              driverHHM?.driverInfo?.prevName
            }
          />
        </>
      )}
      {driverHHM?.driverInfo?.prevNameLicenseNumber && (
        <>
          <QuestionRow
            label={`Previous License Name License Number`}
            value={
              driverHHM?.driverInfo?.prevNameLicenseNumber
            }
          />
        </>
      )}
      {driverHHM?.driverInfo?.diffStateLicensed && (
        <>
          <QuestionRow
            label={`Has this ${isDriverHHM.toLowerCase()} been licensed in another state or country within the past 36 months?`}
            value={
              driverHHM?.driverInfo?.diffStateLicensed == "1" ? "Yes" : "No"
            }
          />
        </>
      )}
      {driverHHM?.driverInfo?.prevState && (
        <>
          <QuestionRow
            label={`Previous License State/Country`}
            value={
              driverHHM?.driverInfo?.prevState
            }
          />
        </>
      )}
      {driverHHM?.driverInfo?.prevStateLicenseNumber && (
        <>
          <QuestionRow
            label={`Previous License State/Country License Number`}
            value={
              driverHHM?.driverInfo?.prevStateLicenseNumber
            }
          />
        </>
      )}
      {driverHHM?.violationInfo?.movingViolations && (
        <>
          <QuestionRow
            label={`Has this ${isDriverHHM.toLowerCase()} received any Moving Violations and/or been in any Accidents or Claims in the last 36 months, regardless of fault?`}
            value={
              driverHHM?.violationInfo?.movingViolations == "1" ? "Yes" : "No"
            }
          />
        </>
      )}
      {driverHHM?.violationInfo?.driverSuspended && (
        <>
          <QuestionRow
            label={`Has this ${isDriverHHM.toLowerCase()} license been suspended or in a suspended status in the last 36 months?`}
            value={
              driverHHM?.violationInfo?.driverSuspended == "1" ? "Yes" : "No"
            }
          />
        </>
      )}
      {driverHHM?.schoolInfo?.enrolledInCollege && (
        <>
          <QuestionRow
            label={`Is this ${isDriverHHM.toLowerCase()} enrolled in a college or university?`}
            value={
              driverHHM?.schoolInfo?.enrolledInCollege == "1" ? "Yes" : "No"
            }
          />
        </>
      )}
      {driverHHM?.schoolInfo?.enrolledInCollege == "1" && (
        <>
          <QuestionRow
            label={"Is school over 100 miles away from the policy address?"}
            value={driverHHM?.schoolInfo?.school100Miles == "1" ? "Yes" : "No"}
          />
          {driverHHM?.schoolInfo?.schoolName && (
            <QuestionRow
              label={"School's Name?"}
              value={driverHHM?.schoolInfo?.schoolName}
            />
          )}
          {driverHHM?.schoolInfo?.schoolCity && (
            <QuestionRow
              label={"School's City?"}
              value={driverHHM?.schoolInfo?.schoolCity}
            />
          )}
          {driverHHM?.schoolInfo?.schoolState && (
            <QuestionRow
              label={"School's State?"}
              value={driverHHM?.schoolInfo?.schoolState}
            />
          )}
        </>
      )}
      {driverHHM?.userInfo?.minorCustody &&
        driverHHM?.editType !== "No longer resides in household." && (
          <>
            <QuestionRow
              label="Does this applicant have custody of a minor?"
              value={driverHHM?.userInfo?.minorCustody == "1" ? "Yes" : "No"}
            />
          </>
        )}
      {driverHHM?.editType && (
        <>
          <QuestionRow
            label={`What would you like to edit about this ${isDriverHHM.toLowerCase()}?`}
            value={driverHHM?.editType}
          />
          {driverHHM?.editType !== "No longer resides in household." && (
            <>
              {driverHHM?.driverInfo?.licenseStatus && (
                <QuestionRow
                  label={isDriverHHM + "'s License Status"}
                  value={driverHHM.driverInfo.licenseStatus}
                />
              )}
              {driverHHM?.driverInfo?.dateOccurred && (
                <QuestionRow
                  label={`When did this occur?`}
                  value={driverHHM?.driverInfo?.dateOccurred}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default DriverHHM_ConfirmForm;
